import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

const HasInsuranceIcon = (props: SVGProps<any>): ReactElement => {
  return (
    <BaseIcon {...props} viewBox="0 0 17 17">
      <path
        d="M14.34 2.025h-1.165c-1.683 0-3.267-.69-4.462-1.876A.47.47 0 0 0 8.364 0c-.13 0-.259.05-.348.15-1.196 1.185-2.78 1.875-4.463 1.875H2.388a.493.493 0 0 0-.498.498V8.5c0 4.472 3.257 6.558 5.408 7.912.28.18.548.339.787.508.09.05.18.08.28.08.099 0 .188-.03.278-.08.23-.16.488-.319.767-.498 2.162-1.354 5.429-3.44 5.429-7.922V2.523a.493.493 0 0 0-.498-.498"
        fill="#1FE0FF"
      />
      <path
        d="M14.84 2.523V8.5c0 4.482-3.267 6.568-5.428 7.922-.28.18-.538.339-.767.498-.09.05-.18.08-.28.08V0c.13 0 .26.05.35.15 1.195 1.185 2.778 1.875 4.462 1.875h1.165c.28 0 .498.22.498.498"
        fill="#6C3DD3"
      />
      <path
        d="M8.364 4.017A4.49 4.49 0 0 0 3.88 8.5a4.49 4.49 0 0 0 4.483 4.482A4.49 4.49 0 0 0 12.846 8.5a4.49 4.49 0 0 0-4.482-4.483"
        fill="#fff"
      />
      <mask
        id="a"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="14"
        height="17"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.34 2.025h-1.165q-.393 0-.776-.049C11.009 1.8 9.722 1.151 8.712.15A.46.46 0 0 0 8.363 0a.47.47 0 0 0-.348.15C6.82 1.335 5.235 2.025 3.552 2.025H2.387a.493.493 0 0 0-.498.498V8.5c0 4.472 3.257 6.558 5.409 7.912l.264.168c.184.115.36.225.523.34.09.05.179.08.278.08s.19-.03.28-.08q.248-.17.537-.351l.23-.147c2.161-1.354 5.429-3.44 5.429-7.922V2.523a.49.49 0 0 0-.499-.498M3.881 8.5a4.49 4.49 0 0 1 4.483-4.482A4.49 4.49 0 0 1 12.846 8.5a4.49 4.49 0 0 1-4.482 4.482A4.49 4.49 0 0 1 3.88 8.5"
          fill="#fff"
        />
      </mask>
      <g mask="url(#a)">
        <path fill="#5EBD82" d="M-3.961-2.125H8.364V19.55H-3.961z" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m8.643 9.988 1.751-1.751a.36.36 0 0 0 0-.522.36.36 0 0 0-.522 0l-1.23 1.223-.372.372-.857-.85a.36.36 0 0 0-.522 0 .36.36 0 0 0 0 .522L8.009 10.1a.35.35 0 0 0 .26.112.35.35 0 0 0 .262-.112z"
        fill="#448EE9"
      />
    </BaseIcon>
  );
};
export default HasInsuranceIcon;
